'use client';

/**
 * Push notifications are handled by the main Workbox Service Worker (`/sw.js`),
 * built from `worker/index.ts`. Do **not** register `/sw-push.js` (or any second SW):
 * same-scope registration replaces `/sw.js` and breaks offline RSC caching.
 */
export function PushServiceWorkerRegistration() {
  return null;
}
